export default __webpack_public_path__ + "static/media/win.dd5525b5.png";